export const crewTypeList = [
    { name: 'Driver', id: 1 },
    { name: 'Conductor', id: 0},
    { name: 'Co-Driver', id: 2 },
    { name: 'Sorting Manager', id: 3 },
    { name: 'Sorting Executive', id: 4 },
    { name: 'Loading Staff', id: 5 },
]
export const headers = [
    {
        headerName: 'SN',
        field: 'sn',
    },
    {
        headerName: 'Crew ID',
        field: 'DriverConductorID',
    },
    {
        headerName: 'Crew Name',
        field: 'DriverConductorName',
    },
    { headerName: 'Crew Type', field: 'CrewType' },
    {
        headerName: 'City Name',
        field: 'CityName',
    },
    {
        headerName: 'Mobile No',
        field: 'ContactNo',
    },
    // {
    //     headerName: 'Modified By',
    //     field: 'ModifiedBy',
    // },
    // {
    //     headerName: 'Modified Date & Time',
    //     field: 'ModifiedOn',
    // },
    { headerName: 'Status', field: 'Status' },
    { headerName: 'Edit', field: 'edit' },
    { headerName: 'Download QR', field: 'downloadQr' },
]
